import React, { PropTypes } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { injectIntl, FormattedMessage, intlShape } from 'react-intl';
import _ from 'lodash';
import './SubscriptionTable.scss';
import BcReactComponent from '@bibliocommons/base-bc-react-component';

export class SubscriptionTable extends BcReactComponent {
  static getRowItems() {
    return [
      {
        id: 'collection',
        get: row => row.get('collection')
      },
      {
        id: 'callNumber',
        get: row => row.get('callNumbers').join(', ')
      },
      {
        id: 'mediaType',
        get: row => row.get('mediaType')
      },
      {
        id: 'status',
        get: row => row.get('status')
      },
      {
        id: 'notes',
        get: row => SubscriptionTable.renderNotes(row.get('notes'))
      },
      {
        id: 'runDuration',
        get: row => SubscriptionTable.renderDurations(row.get('runDuration'))
      }
    ];
  }

  static renderDuration(duration) {
    const beginText = duration.get('beginText');
    const endText = duration.get('endText');
    const note = duration.get('note');

    if (!beginText && !endText && !note) {
      return null;
    }

    let formattedDuration = beginText || '';
    if (endText) {
      formattedDuration += ` - ${endText}`;
    }

    if (note) {
      formattedDuration += ` (${note})`;
    }
    return formattedDuration;
  }

  static renderDurations(durations) {
    if (durations.isEmpty()) {
      return null;
    }

    if (durations.size === 1) {
      return SubscriptionTable.renderDuration(durations.first());
    }

    return (
      <ul className="run-duration-list">
        {durations.map((duration) => SubscriptionTable.renderDurations(duration))}
      </ul>
    );
  }

  static renderNotes(notes) {
    if (notes.size === 0) { return null; }
    if (notes.size === 1) { return notes.get(0); }
    const list = notes.map((item, index) => (<li key={index}>{item}</li>));

    return (
      <ul>
        {list}
      </ul>
    );
  }

  static renderSubscriptions(row) {
    return (
      <div className="subscription-item">
        {SubscriptionTable.getRowItems().map(({ id, get }) => !_.isEmpty(get(row)) && (
          <div className="row">
            <div className="col-xs-3">
              <FormattedMessage tagName="strong" id={id} />
            </div>
            <div className="col-xs-9">{get(row)}</div>
          </div>
        ))}
      </div>
    );
  }

  static renderGroup(group) {
    return (
      <div className="subscription-group">
        { group.get('label') ? <h4>{group.get('label')}</h4> : null }
        { group.get('subscriptions').map(SubscriptionTable.renderSubscriptions) }
      </div>
    );
  }

  render() {
    const { subscriptions } = this.props;
    return (
      <div className="cp-subscription-table">
        {subscriptions.map(SubscriptionTable.renderGroup)}
      </div>
    );
  }
}

SubscriptionTable.propTypes = {
  subscriptions: ImmutablePropTypes.listOf(ImmutablePropTypes.mapOf({
    label: PropTypes.string,
    subscriptions: ImmutablePropTypes.listOf(
      ImmutablePropTypes.mapOf({
        collection: PropTypes.string,
        status: PropTypes.string,
        callNumbers: ImmutablePropTypes.listOf(PropTypes.string),
        mediaType: PropTypes.string,
        notes: ImmutablePropTypes.listOf(PropTypes.string),
        runDuration: ImmutablePropTypes.mapOf({
          beginText: PropTypes.string,
          endText: PropTypes.string,
          note: PropTypes.note
        })
      })
    )
  })).isRequired,
  intl: intlShape
};


export default injectIntl(SubscriptionTable);



// WEBPACK FOOTER //
// ./app/components/shared/SubscriptionTable/SubscriptionTable.jsx